const utils = require('../../lib/utils')

module.exports = {
	extends: [
		'/',
		'base',
		'form',
		'form'
	],

	config: {
		contextClass: '',
		actionBossComponentClass: 'base_mediaManagement_image_image',
		resourceConnected: false
	},

	events: {
		/**
		 * this event will be fired any time a click will be performed.
		 * so it is possible to control the click-behaviour within this event-handler without the necessity of registering an event-handler for each button.
		 *
		 * @param event
		 */
		click: function (event) {
			event.preventDefault()
			event.stopImmediatePropagation()
			utils.performButtonAction(event, event.data.component.config.actionBossComponentClass).then(function(context){
				event.data.component.callHandler('onAction', [context.response, context.fieldType, context.buttonContext, context.buttonMode])
			})
		}
	},

	hooks: {
		async onDecision($element, options){
			// NOTE: this hook should be overwritten by real actionsForm
			console.log('NON-OVERWRITTEN_onDecision-HOOK | options', options)
		}
	}
}